// extracted by mini-css-extract-plugin
export default {"link":"ShopperZuluLogo_link__pu0kA","img":"ShopperZuluLogo_img__siNHl","imgMark":"ShopperZuluLogo_imgMark__AUTQB","imgHero":"ShopperZuluLogo_imgHero__MWi03"};